/**
 * What the billing schedule says of a stage, an activation or an agreement (D-216): of its lines,
 * how many overdue, due and invoiced — the invoice's number when a stage has one.
 */
export function billingMarks(lines, prefix) {
  const own = (lines || []).filter((l) => l.key === prefix || l.key.startsWith(`${prefix}:`))
  const count = (s) => own.filter((l) => l.status === s).length
  return { overdue: count('overdue'), due: count('due'), invoiced: count('invoiced'), number: own.length === 1 ? own[0].invoice?.number || null : null, any: own.length > 0 }
}

/** An agreement's lines: by its uuid. */
export function agreementMarks(lines, agreementUuid) {
  const own = (lines || []).filter((l) => l.agreement_uuid === agreementUuid)
  const count = (s) => own.filter((l) => l.status === s).length
  return { overdue: count('overdue'), due: count('due'), invoiced: count('invoiced'), any: own.length > 0 }
}
